<template>
  <div>
    <div class="page_main">
      <div class="box-shadow top-box">
        <div class="global-title" style="margin-right: 12px">{{ title }}</div>
        <slot name="top"></slot>
      </div>
      <div style="padding: 20px 28px">
        <slot></slot>
      </div>
      <div class="bottom-box" v-if="showBottom">
        <slot name="bottom"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: "",
    showBottom: {
      type: Boolean,
      default: true,
    },
    showTop: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.page_main {
  min-width: 1100px;
  background: #fff;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  opacity: 1;
  margin: 10px 20px 20px 20px;
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  .top-box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .global-title {
      border-bottom: none;
    }
  }
  .bottom-box {
    // display: flex;
    height: 80px;
    border-top: 1px solid #f6f6f6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
